import { apiUrl2, xTravelWorldUrl } from '../../../settings'

export const addXTravelTransferOtpUrl = () => {
  return xTravelWorldUrl + '/x-travel/addTransferSendOtp'
}

export const addXTravelTransferUrl = () => {
  return xTravelWorldUrl + '/x-travel/addTransfer'
}

export const getAllTransfer = () => {
  return xTravelWorldUrl + '/x-travel/getAllTransfer'
}

export const getSingleUserApiUrl = () => {
  return xTravelWorldUrl + '/getSingleUserApi'
}

export const getAllWithdrawals = () => {
  return apiUrl2 + '/x-travel/withdrawals'
}
